import { createReducer } from '@reduxjs/toolkit';
import { setActiveNavKey } from '../actions/LocalCacheActions';

const initState: InitStateType = { activeNavKey: 'home' };

const LocalCacheReducer = createReducer(initState, {
	//* active nav key
	[setActiveNavKey.type]: (state, { payload }) => ({ ...state, activeNavKey: payload }),
});

type InitStateType = { activeNavKey: string };

export default LocalCacheReducer;
